import { mapState } from 'vuex';
import {
  DELETE_ALL_IMAGES,
  DELETE_IMAGES,
  GET_IMAGES_COLLECTION,
  UPDATE_ALL_IMAGES,
  UPDATE_IMAGES,
  UPLOAD_IMAGES
} from "../store/images/actions";

import notifications from "./notifications";

export default {
  data() {
    return {
      images: [],
      localFiles: [],
      maxSize: 20480,
    }
  },
  mixins: [
    notifications
  ],
  methods: {
    getImages(slug, ownerId) {
      this.$store.dispatch(GET_IMAGES_COLLECTION, {slug, ownerId});
    },
    uploadImage(slug, ownerId, file, position = null) {      
      return this.$store.dispatch(UPLOAD_IMAGES, {slug, ownerId, data: {file, position}});
    },
    updateImage(slug, ownerId, imageId, data) {
      return this.$store.dispatch(UPDATE_IMAGES, {slug, ownerId, imageId, data});
    },
    updateAllImages(slug, ownerId, data) {
      return this.$store.dispatch(UPDATE_ALL_IMAGES, {slug, ownerId, data});
    },
    deleteAllImages(slug, ownerId) {
      this.$store.dispatch(DELETE_ALL_IMAGES, {slug, ownerId})
    },
    deleteImage(slug, ownerId, imageId) {
      this.$store.dispatch(DELETE_IMAGES, {slug, ownerId, imageId})
    },
    mapNewFiles(files) {
      return files.map((file) => {
        return {
          path: file.dataURL,
          position: file.index,
          hash: file.hash
        }
      });
    },
    mapOldFiles(files) {
      return files.map((file) => {
        let item = {
          id: file.id,
          path: file.full_path,
          position: file.position
        };
        if (!!file.sizes_full_path) {
          item['sizes'] = file.sizes_full_path;
        }
        return item;
      });
    },
    mapImages() {
      const oldFiles = this.mapOldFiles(this.items);
      const newFiles = this.mapNewFiles(this.localFiles);
      const images = [...oldFiles, ...newFiles];
      if (this.sortable) {
        return this.sort(images);
      }
      this.images = images;
    },
    sort(images) {
      this.images = images.sort((a, b) => a.position - b.position);
    },
    validateFileSize(file) {
      let size = file.size / 1024;

      if (size > this.maxSize) {
        return false;
      }

      return true;
    }
  },
  computed: {
    ...mapState({
      items: state => state.images.getCollectionRequest.collection,
      errors: state => state.images.uploadRequest.validation,
    })
  },
  watch: {
    errors: {
      handler(newVal) {
        for (let k in newVal) {
          this.showNotification(newVal[k][0], 'error')
        }
      },
      deep: true
    },
    items(newVal, oldVal) {
      if (oldVal.length > 0 && newVal.length === 0) {
        this.localFiles = [];
      } else {
        this.mapImages()
      }
    },
    localFiles() {
      this.mapImages();
    }
  }
}
